"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useSession } from "./session-context";

export function AdminGuard({ children }: { children: React.ReactNode }) {
	const { session, isLoading } = useSession();
	const router = useRouter();

	useEffect(() => {
		if (isLoading || !session) return;

		// Club owners without admin access get redirected to club view
		if (session.role === "club_owner") {
			router.replace("/club");
		}
	}, [session, isLoading, router]);

	if (isLoading) return null;
	if (session?.role === "club_owner") return null;

	return <>{children}</>;
}

export function ClubGuard({ children }: { children: React.ReactNode }) {
	const { session, isLoading } = useSession();
	const router = useRouter();

	// A signed-in user with no club has nothing to render in the club-scoped
	// portal — every page needs an active club. Send them to the create-club
	// wizard instead of letting club-less pages mount and 404.
	const needsSetup = !!session && session.club_ids.length === 0;

	useEffect(() => {
		if (isLoading || !session) return;

		if (needsSetup) {
			router.replace("/setup");
		}
	}, [isLoading, session, needsSetup, router]);

	if (isLoading || needsSetup) return null;

	return <>{children}</>;
}
